<div class="flex rounded-lg max-h-[calc(100vh-124px)]">
  <section class="w-120" [ngClass]="{'h-auto max-h-[calc(100vh-80px)]': loadingAvailabilities}">
    <article id="header" class="flex primary-green-2-background rounded-ss-lg rounded-se-lg">
      <div class="mt-4 ml-8 mb-4 w-full">
        <!-- @if (dataLoaded && editFavourite) { -->
          @if (currentStep === 1) {
            <h1 class="font-bold text-[22px] primary-purple-text">{{ literalService.get('bookings.newBooking', true) }}</h1>
            <label class="font-semibold text-lg">{{ literalService.get('bookings.information', true) }}</label>
          } @else if (currentStep === 2) {
            <div class="flex items-center">
              <img [src]="images.arrowLeft" alt="back" class="h-6 w-6 cursor-pointer" (click)="back()" />
              <div class="ml-5">
                @if (editFavourite) {
                  <h1 class="font-bold text-[22px] primary-purple-text">{{ literalService.get('favourites.editFavourite', true) }}</h1>
                } @else {
                  <h1 class="font-bold text-[22px] primary-purple-text">{{ literalService.get( newFavourite ? 'favourites.newFavourite' : 'bookings.newBooking', true) }}</h1>
                }
                <label class="font-semibold text-lg">{{ literalService.get('bookings.information', true) }}</label>
              </div>
            </div>
          } @else if (currentStep === 3) {
            <div class="flex items-center">
              <img [src]="images.arrowLeft" alt="back" class="h-6 w-6 cursor-pointer" (click)="back()" />
              <div class="ml-5">
                <h1 class="font-bold text-[22px] primary-purple-text">{{ literalService.get((newBooking.multipleDates ? 'bookings.newBookings' : 'bookings.newBooking'), true) }}</h1>
                <label class="font-semibold text-lg">{{ literalService.get('bookings.availabilities', true) }}</label>
              </div>
            </div>
          }
        <!-- } @else {
            <div class="flex items-center mt-4">
              <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '40px', 'width': '300px' }"></ngx-skeleton-loader>
            </div>
        } -->
      </div>

      @if (!newFavourite) {
        <div class="mt-4 mr-5 justify-end">
          <div class="flex main rounded-[50%] h-14 w-14 justify-center items-center">
            <div class="quarter third1" [ngClass]="{ 'block': steps.includes(1), 'hidden': !steps.includes(1) }"></div>
            <div class="quarter third2" [ngClass]="{ 'block': steps.includes(2), 'hidden': !steps.includes(2) }"></div>
            <div class="quarter third3" [ngClass]="{ 'block': steps.includes(3), 'hidden': !steps.includes(3) }"></div>
            <label class="flex font-bold text-[22px] primary-purple-text cutout justify-center items-center">
              {{ currentStep }}/{{ numberSteps }}
            </label>
          </div>
        </div>
      }
    </article>
    @if (currentStep === 3 && !loadingAvailabilities && availabilities.length > 0) {
      <article class="flex items-center primary-purple-light-2-background p-2 pl-8">
        <div class="flex items-center">
          <img [src]="images.booking.date" class="h-6 w-6 mr-2" />
          <label class="font-normal text-base mr-6">{{ getDate() }}</label>
          <img [src]="images.pax" class="h-6 w-6 mr-1" />
          <label class="font-normal text-base mr-2">{{ getPax() }}</label>
          @if (showPrm) {
            <img [src]="images.prm" class="h-6 w-6 mr-1" />
            <label class="font-normal text-base">{{ getPrm() }}</label>
          }
        </div>
        @if (newBooking.multipleDates) {
          <div class="flex absolute items-center right-0" [ngClass]="{'pr-8': !hasAlterations, 'pr-24': hasAlterations}">
            <div class="cursor-pointer w-5 h-5 rounded neutrals-grey-02-background" (click)="!previousAvailabilityDisabled() && previousAvailability()">
              <img [src]="images.arrow" alt="previousAvailability" class="h-full w-full rounded rotate-180 p-1" [ngClass]="{'opacity-40 disabled': previousAvailabilityDisabled()}" />
            </div>
            <div class="mx-1">
              <label class="font-normal text-base">{{ currentPage + 1 }}/{{ totalElements }}</label>
            </div>
            <div class="cursor-pointer w-5 h-5 rounded neutrals-grey-02-background" (click)="!nextAvailabilityDisabled() && nextAvailability()">
              <img [src]="images.arrow" alt="nextAvailability" class="h-full w-full rounded p-1" [ngClass]="{'opacity-40 disabled': nextAvailabilityDisabled()}" />
            </div>
          </div>
        }
      </article>
    }
    @if (currentStep === 1 || currentStep === 2 && !creatingRecurrent && !editingRecurrent && !creatingNewFavourite) {
      <article id="body" class="bg-white pb-6 pt-6 pl-7 pr-7! max-h-[80%]" [ngClass]="{'overflow-scroll' : currentStep === 2}">
        @if (bookingFromFavourite && !newFavourite && !isEditRecurrent) {
          <div class="flex items-center">
              <div class="flex items-center">
                <input name="simpleBooking" type="radio" class="radio radio-xs" [checked]="!newBooking.recurrentBooking" (change)="newBooking.recurrentBooking = false; changeRecurrentBooking()" />
                <label class="font-normal text-base ml-1">{{ literalService.get('bookings.simple', true) }}</label>
              </div>
              <div class="flex items-center ml-4">
                <input name="simpleBooking" type="radio" class="radio radio-xs" [checked]="newBooking.recurrentBooking" (change)="newBooking.recurrentBooking = true; changeRecurrentBooking()" [disabled]="favouriteIsAlreadyRecurring"/>
                <label class="font-normal text-base ml-1">{{ literalService.get('bookings.recurrent', true) }}</label>
              </div>
          </div>
        }
        @for (element of bookingForm; track $index) {
          @if (element.edit.visible) {
            <div class="relative -ml-7 -mr-7 px-7 pt-4 pb-4 -mb-4" [ngClass]="{'hidden': !steps.includes(element.step), 'highlight-bg rounded-none': recurrentElements(element), 'mt-0': element.title === 'bookings.data.town' && !newBooking.recurrentBooking, 'mt-4': element.title === 'bookings.data.town' && newBooking.recurrentBooking, 'flex justify-between': element.informativeToNoChange && !newFavourite, 'pb-8':  element.informativeToNoChange && !newFavourite && newBooking.recurrentBooking }">
              @if (element.title === 'bookings.data.time') {
                <div class="absolute right-10 top-4 flex items-center gap-1 z-1">
                  <button type="button"
                          class="px-2 py-0.5 rounded-full text-xs font-medium cursor-pointer transition-colors"
                          [ngClass]="!newBooking.isArrivalTime ? 'primary-purple-background text-white' : 'neutrals-grey-01-background neutrals-grey-06-text'"
                          (click)="set(false, 'isArrivalTime')">
                    {{ literalService.get('bookings.departure', true) }}
                  </button>
                  <button type="button"
                          class="px-2 py-0.5 rounded-full text-xs font-medium cursor-pointer transition-colors"
                          [ngClass]="newBooking.isArrivalTime ? 'primary-purple-background text-white' : 'neutrals-grey-01-background neutrals-grey-06-text'"
                          (click)="set(true, 'isArrivalTime')">
                    {{ literalService.get('bookings.arrival', true) }}
                  </button>
                </div>
              }
              <app-input  [data]="element"
                          [edit]="true"
                          [independent]="true"
                          (setEventEmitter)="set($event.value, element.edit?.valueToChange)"
                          (scrollEventEmitter)="scroll($event)"
                          (searchEventEmitter)="search($event, element.edit?.valueToChange)"
                          (changeEventEmitter)="change($event, element.edit?.valueToChange)" />
              @if (element.title === 'bookings.data.originStop') {
                <button class="absolute flex justify-center items-center rounded-full neutrals-grey-01-background h-7 w-7 right-10 mt-2 z-1" [ngClass]="{'hidden': !possibleSwap, 'opacity-50 cursor-not-allowed!': swappingStops}" [disabled]="swappingStops" (click)="changeStops()">
                  @if (swappingStops) {
                    <span class="loading loading-spinner loading-xs"></span>
                  } @else {
                    <img [src]="images.booking.changeStops" class="h-6 w-6 rotate-90 p-0.5" />
                  }
                </button>
              }
              @if (element.title === 'bookings.data.originStop' && stopOriginNotification) {
                <app-input-notifications class="absolute" [ngClass]="{ 'fadeIn': stopOriginNotification, 'fadeOut': !stopOriginNotification }" [title]="element.title+'IncompatibleTitle'" [text]="element.title+'IncompatibleText'"></app-input-notifications>
              }
              @if (element.title === 'bookings.data.destinationStop' && stopDestinationNotification) {
                <app-input-notifications class="absolute" [ngClass]="{ 'fadeIn': stopDestinationNotification, 'fadeOut': !stopDestinationNotification }" [title]="element.title+'IncompatibleTitle'" [text]="element.title+'IncompatibleText'"></app-input-notifications>
              }
              @if (element.informativeToNoChange && !newFavourite) {
                <div class="inline-flex p-1 cursor-pointer neutrals-grey-01-background rounded justify-end items-center gap-1" (click)="openFavourite.emit(newBooking.user.id)">
                    <img [src]="images.user.star" class="w-6 h-6 mr-1 cursor-pointer" />
                    <div class="neutrals-grey-06-text text-base font-normal">{{ literalService.get('favourites.routes', true)}}</div>
                </div>
              }
              @if (isD2DBooking && element.title === 'bookings.data.originStop') {
                @if (newBooking.door2DoorOriginFreeStops && element.value) {
                  <button class="absolute flex justify-center items-center rounded-full h-7 w-7 right-17.5 bottom-5.5 clear-icon" (click)="onClearElement('origin')">
                    <img [src]="images.close" class="h-4 w-4" />
                  </button>
                }
                @if (isD2DFreeStopsAllowed) {
                  <button class="absolute flex justify-center items-center rounded-full h-7 w-7 right-10 bottom-5.5" (click)="onEditCustomStop('origin')" [ngClass]="{'primary-purple-light-background': newBooking.door2DoorOriginFreeStops, 'neutrals-grey-01-background': !newBooking.door2DoorOriginFreeStops}">
                    <img [src]="images.booking.stops" class="h-6 w-6 p-0.5" [ngClass]="{'white-icon': newBooking.door2DoorOriginFreeStops}" />
                  </button>
                }
              }
              @if (isD2DBooking && element.title === 'bookings.data.destinationStop') {
                @if (newBooking.door2DoorDestinationFreeStops && element.value) {
                  <button class="absolute flex justify-center items-center rounded-full h-7 w-7 right-17.5 bottom-5.5 clear-icon" (click)="onClearElement('destination')">
                    <img [src]="images.close" class="h-4 w-4" />
                  </button>
                }
                @if (isD2DFreeStopsAllowed) {
                  <button class="absolute flex justify-center items-center rounded-full h-7 w-7 right-10 bottom-5.5" (click)="onEditCustomStop('destination')" [ngClass]="{'primary-green-background': newBooking.door2DoorDestinationFreeStops, 'neutrals-grey-01-background': !newBooking.door2DoorDestinationFreeStops}">
                    <img [src]="images.booking.stops" class="h-6 w-6 p-0.5" [ngClass]="{'white-icon': newBooking.door2DoorDestinationFreeStops}" />
                  </button>
                }
              }
              @if (element.title === 'bookings.data.destinationStop') {
                <button class="absolute flex justify-center items-center rounded-full neutrals-grey-01-background h-7 w-7 right-10 mt-4 z-1" [ngClass]="{'hidden': !this.newBooking.destinationStop}" (click)="showChangeSeatsModal.emit({newBooking, editable: !newBooking.recurrentBooking})">
                  <img [src]="images.userAttr" class="h-6 w-6" />
                </button>
              }
            </div>
          }
        }
      </article>
      <article id="footer" class="flex bg-white pb-6 justify-center rounded-es-lg rounded-ee-lg pt-1 pl-7 pr-7" [ngClass]="{'hidden': !newBooking.targetUserId || currentStep === 1}">
        @if (newBooking.recurrentBooking) {
          @if (isEditRecurrent) {
            <input type="button" class="primary text-white gap-4 border-2 font-semibold h-14 w-3/4 uppercase cursor-pointer" [disabled]="disabledCreateRecurrent()" (click)="editRecurrent()" [value]="literalService.get('bookings.actions.editRecurrent.title', true)" />
          } @else {
            <input type="button" class="primary text-white gap-4 border-2 font-semibold h-14 w-3/4 uppercase cursor-pointer" [disabled]="disabledCreateRecurrent()" (click)="createRecurrent()" [value]="literalService.get('bookings.actions.createRecurrent.title', true)" />
          }
        }
        @else {
          @if (newFavourite) {
            <input type="button" class="primary text-white gap-4 border-2 font-semibold h-14 w-3/4 uppercase cursor-pointer" [disabled]="disabledCreateFavourite()" (click)="editFavourite ? editFavouriteAction() : createFavourite()" [value]="editFavourite ? literalService.get('bookings.actions.editFavourite.title', true) : literalService.get('bookings.actions.createFavourite.title', true)" />
          }
          @else {
            <input type="button" class="primary text-white gap-4 border-2 font-semibold h-14 w-3/4 uppercase cursor-pointer" [disabled]="disabledViewAvailabilities()" (click)="getAvailabilities()" [value]="literalService.get('bookings.viewAvailabilities', true)" />
          }
        }
      </article>
    } @else if (creatingNewFavourite) {
      <article class="bg-white w-full pb-6 pt-4 pl-7 pr-7 justify-center rounded-es-lg rounded-ee-lg">
        <ng-lottie [options]="star" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
      </article>
    } @else if (currentStep === 1 || currentStep === 2 && creatingRecurrent) {
      <article class="bg-white w-full pb-6 pt-4 pl-7 pr-7 justify-center rounded-es-lg rounded-ee-lg">
          <ng-lottie [options]="star" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
          <div class="flex items-center justify-center">
              <h3 class="text-xl font-bold mb-4 -mt-4 text-gray-500 dark:text-gray-400 primary-purple-light-text">{{ literalService.get('bookings.actions.createRecurrent.creating', true)}}</h3>
          </div>
      </article>
    } @else if (currentStep === 1 || currentStep === 2 && editingRecurrent) {
      <article class="bg-white w-full pb-6 pt-4 pl-7 pr-7 justify-center rounded-es-lg rounded-ee-lg">
          <ng-lottie [options]="star" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
          <div class="flex items-center justify-center">
              <h3 class="text-xl font-bold mb-4 -mt-4 text-gray-500 dark:text-gray-400 primary-purple-light-text">{{ literalService.get('bookings.actions.editRecurrent.creating', true)}}</h3>
          </div>
      </article>
    } @else if (currentStep === 3) {
      @if (loadingAvailabilities) {
        <article class="flex bg-white w-full pb-6 pt-4 pl-7 pr-7 justify-center rounded-es-lg rounded-ee-lg">
            <ng-lottie [options]="optionsPin" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
        </article>
      } @else if (creatingBooking) {
        <article class="flex bg-white w-full pb-6 pt-4 pl-7 pr-7 justify-center rounded-es-lg rounded-ee-lg">
          <ng-lottie [options]="optionsBus" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
        </article>
      } @else {
        <article id="body" class="bg-white pb-6 pt-1 pl-7 pr-6 rounded-es-lg rounded-ee-lg">
          <app-booking-availabilities [availabilities]="availabilitiesSeparateByDate" [showedDate]="getDate()" [newBooking]="newBooking" [serviceInfos]="serviceInfos" [loadingAvailabilities]="loadingAvailabilities" [availabilitiesSelected]="availabilitiesSelected" [allAvailabilitiesSelected]="checkAllAvailabilitiesSelected()" (nextAvailability)="nextAvailability($event)" (book)="createBookings($event)" (bookMultiple)="createBookings($event)" (checkAllAvailabilitiesSelected)="checkAllAvailabilitiesSelected()" (showMaxReservationTimeModalEventEmitter)="showMaxReservationTimeModal()" (showExceedingKmLimitModalEventEmitter)="showExceedingKmLimitModal()" (sendNotificationChange)="set($event, 'notify')"></app-booking-availabilities>
        </article>
      }
    }
  </section>
  @if (currentStep === 3 && !loadingAvailabilities && !creatingBooking && availabilityDetail) {
    <app-booking-availability-detail class="ml-4 mt-23.25 self-start" [trip]="availabilityDetail" [newBooking]="newBooking" [pax]="getPax()" (closeDetail)="availabilityDetail = undefined"></app-booking-availability-detail>
  }
  @if (hasAlterations && currentStep === 2) {
    <details class="dropdown dropdown-start ml-4" #alterationDropdown>
      <summary class="list-none cursor-pointer rounded-lg shadow secondary-yellow-02-background py-1.5 px-2">
        <img [src]="images.alert" class="h-8 w-8" alt="alterationWarning" />
      </summary>
      <div tabindex="0" class="dropdown-content z-50 mt-1">
        <app-modal-alteration [id]="'alteration'" [title]="literalService.get('bookings.alterations.title', true)" [text]="'BBBB'" [services]="serviceInfos" (close)="alterationDropdown.removeAttribute('open')"></app-modal-alteration>
      </div>
    </details>
  }
</div>